export default __webpack_public_path__ + "static/cool-1-c2671f3c02e3f97b42c0926ffbdde5b4.svg";